import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PosesionHero from './components/PosesionHero';
import PosesionRisk from './components/PosesionRisk';
import PosesionForWho from './components/PosesionForWho';
import PosesionIncludes from './components/PosesionIncludes';
import PosesionCases from './components/PosesionCases';
import PosesionWhyUs from './components/PosesionWhyUs';
import PosesionTestimonials from './components/PosesionTestimonials';
import PosesionFinalCTA from './components/PosesionFinalCTA';
import PosesionForm from './components/PosesionForm';

const PosesionEfectivaPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <PosesionHero />
        <PosesionRisk />
        <PosesionForWho />
        <PosesionIncludes />
        <PosesionTestimonials />
        <PosesionCases />
        <PosesionWhyUs />
        <PosesionFinalCTA />
        {/* Form section — anchor target for scroll */}
        <section id="form-section" className="py-16 bg-white scroll-mt-20">
          <PosesionForm />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PosesionEfectivaPage;
